
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { MemberManager } from 'modules/App/server';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import Hero from 'modules/common/components/Hero';
import { useAuthModal } from 'modules/auth';
import dbConnect from 'utils/db';
import { User } from 'modules/App/interfaces';
import { Section } from '@/lib/components/layout/section';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/lib/components/ui/breadcrumb';
import EmptyState from 'modules/common/components/EmptyState';
import omit from 'lodash/fp/omit';
import RecruitersList from 'modules/App/components/RecruitersList';
import RecruitersCities from 'modules/App/components/RecruitersCities';
import { track } from '@/lib/analytics/client';
import { whatsappDorothee } from 'modules/App/config';
export interface MissionsProps {
    users: User[];
    city: string;
    cities: string[];
}
function Missions({ users, city, cities }: MissionsProps) {
    const { toggleModal } = useAuthModal();
    return (<HeaderLayout title={`${users.length} recruteur${users.length > 1 ? 's' : ''} prêt${users.length > 1 ? 's' : ''} à collaborer à ${city}`} description="Tu souhaites intéragir avec un de ces recruteurs .">
      <Hero title={<>
            <span className="text-primary">{users.length}</span> recruteur{users.length > 1 ? 's' : ''} prêt{users.length > 1 ? 's' : ''} à collaborer
            <br />à <span className="text-primary">{city}</span>
          </>} description={<>
            Tu cherches à collaborer avec des recruteurs de confiance à <span className="text-primary">{city}</span> ?
            <br />
            <strong className="link link-primary" onClick={() => toggleModal()}>
              Inscris-toi
            </strong>{' '}
            maintenant
            <div className="italic text-sm mt-5">
              <strong>Vous êtes une entreprise et cherchez un recruteur&nbsp; à {city}&nbsp;?</strong>.{' '}
              <a href={`${whatsappDorothee}?text=${encodeURIComponent(`Bonjour Dorothée, je cherche un recruteur à ${city} et j'ai vu sur Headlinker que vous pouviez me mettre en relation`)}`} onClick={() => track('recruiters.company.contact', { city })} target="_blank" rel="noopener noreferrer" className="link link-secondary">
                Nous vous mettons en relation.
              </a>
            </div>
          </>}/>
      <Section variant="full" className="container mx-auto">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href={`/recruiters`}>Recruteurs dans toutes les villes</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>
                Recruteurs à <strong>{city}</strong>
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </Section>
      {users.length === 0 ? (<EmptyState title={`Aucun recruteur disponible en ce moment à ${city}`} className="my-16"/>) : (<RecruitersList recruiters={users}/>)}
      <Section className="bg-gray-50">
        <RecruitersCities cities={cities}/>
      </Section>
    </HeaderLayout>);
}
export const getStaticPaths: GetStaticPaths = async () => {
    await dbConnect();
    const { cities } = await MemberManager.listNotConnected();
    const paths = cities?.map((area) => ({
        params: { slug: area.slug },
    })) || [];
    return {
        paths,
        fallback: 'blocking',
    };
};
const getStaticProps: GetStaticProps<MissionsProps> = async ({ params }) => {
    await dbConnect();
    const { cities: allCities } = await MemberManager.listNotConnected();
    const city = allCities.find((cityObject) => cityObject.slug === (params?.slug as string));
    const { items: users, cities } = await MemberManager.listNotConnected({
        filter: { area: omit(['slug'])(city) },
    });
    let citiesList = cities.filter((city) => city.slug !== params?.slug).map((city) => city.name);
    if (citiesList.length === 0) {
        citiesList = allCities.map((city) => city.name);
    }
    return {
        props: {
            city: params?.slug as string,
            users: JSON.parse(JSON.stringify(users)),
            cities: JSON.parse(JSON.stringify(citiesList)),
        },
        revalidate: 60,
    };
};
export default Missions;

    async function __Next_Translate__getStaticProps__1989496f59d__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/recruiters/ville/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989496f59d__ as getStaticProps }
  